import { HttpCache, HttpCacheInitialState, ReduxAction } from "../models";
import { HttpCacheTypes } from "../types";

export const HttpCacheState = (state: HttpCache = HttpCacheInitialState, action?: ReduxAction): HttpCache => {
    if (!action) return state;
    const now = new Date().getTime();
    switch (action.type) {
        case HttpCacheTypes.ADD_HTTP_CACHE:
            let s = [...state];
            const cache = s.find((x) => x.key.toLowerCase() === action.payload.key.toLowerCase());
            if (cache) {
                cache.expiry = action.payload.expiry + now;
                cache.value = action.payload.value;
            }
            else {
                s = [...s, { ...action.payload, expiry: action.payload.expiry + now }];
            }

            return s;
        case HttpCacheTypes.REMOVE_HTTP_CACHE:
            return [...state.filter((x) => x.key.toLowerCase() !== action.payload.toLowerCase())];
        case HttpCacheTypes.CLEAN_UP_HTTP_CHACHE:
            return [...state.filter((x) => x.expiry > now)];
    }

    return state;
};